import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';
// ngrx store
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appCheckEmpty][ngModel]',
})
export class CheckEmptyDirective implements OnInit, OnDestroy {

  private _modelSubscription: Subscription;

  constructor(
    private _ele: ElementRef,
    private _render: Renderer2,
    private _model: NgModel
  ) { }

  ngOnInit() {
    this._modelSubscription = this._model.valueChanges
      .subscribe((event) => {
        if (event === '' || typeof event === 'undefined' || event === null) {
          this._render.addClass(this._ele.nativeElement, 'ng-empty');
          this._render.removeClass(this._ele.nativeElement, 'ng-not-empty');
        } else {
          this._render.addClass(this._ele.nativeElement, 'ng-not-empty');
          this._render.removeClass(this._ele.nativeElement, 'ng-empty');
        }
      });
  }

  ngOnDestroy() {
    if (this._modelSubscription) {
      this._modelSubscription.unsubscribe();
    }
  }
}
